import {
  useFilterCompanies,
  useFilterJobs,
  useUserContext,
} from "@/providers/contexts";
import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useCompanyFilterOptions, useJobPostFilterOptions } from "@/hooks";
import { FilterPanelProps } from "../FilterPanel";

export interface CompanySizeFilterProps {
  page: FilterPanelProps["page"];
}

// Only available to premium users
export const CompanySizeFilter = ({ page }: CompanySizeFilterProps) => {
  const { disabledBasicContent, disabledProContent, isAuthenticated } =
    useUserContext();

  const { companySizes: companyCompanySizes } = useCompanyFilterOptions();
  const { filters: jobPostFilters } = useJobPostFilterOptions();

  const {
    filters: jobFilters,
    dispatch: jobDispatch,
    loading: jobLoading,
  } = useFilterJobs();
  const {
    filters: companyFilters,
    dispatch: companyDispatch,
    loading: companyLoading,
  } = useFilterCompanies();

  const isSearchPage = page === "search";
  const companySizes = isSearchPage
    ? jobPostFilters?.companySizes || []
    : companyCompanySizes;
  const { selectedCompanySizes } = isSearchPage ? jobFilters : companyFilters;
  const dispatch = isSearchPage ? jobDispatch : companyDispatch;

  const disabledContent =
    disabledBasicContent || disabledProContent || !isAuthenticated;
  const loading = jobLoading || companyLoading;

  const options: AutocompleteOption[] = companySizes.map(size => ({
    key: size.id,
    value: size.size_range,
  }));

  const selectedOptions = selectedCompanySizes.map(selected => {
    const size = options.find(option => option.value === selected.size_range);

    return {
      key: size?.key ?? "",
      value: size?.value ?? "",
    };
  });

  return (
    <Autocomplete
      componentName="company-size"
      inputLabel="Company Size"
      options={options}
      value={selectedOptions}
      multiple
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = companySizes.filter(size =>
          selectedValues.some(el => el.key === size.id),
        );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedCompanySizes: selected },
        });
      }}
      loading={loading}
      disabled={disabledContent}
      tooltipMessage={
        disabledContent
          ? "Upgrade your account to access this feature"
          : undefined
      }
      readMoreLink="/memberships"
    />
  );
};
